import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TimeoutError, catchError, throwError, timeout } from 'rxjs';

import { APP_CONFIG } from '../tokens/app-config.token';

export const DEFAULT_REQUEST_TIMEOUT_MS = 30_000;
export const REQUEST_TIMEOUT_MESSAGE = 'El servidor tardó demasiado en responder. Intenta de nuevo.';
export const REQUEST_TIMEOUT_MS = new HttpContextToken<number>(() => DEFAULT_REQUEST_TIMEOUT_MS);

function hasTimeout(timeoutMs: number): boolean {
  return Number.isFinite(timeoutMs) && timeoutMs > 0;
}

export const timeoutInterceptor: HttpInterceptorFn = (req, next) => {
  const config = inject(APP_CONFIG);
  const timeoutMs = req.context.get(REQUEST_TIMEOUT_MS);

  if (!req.url.startsWith(config.apiUrl) || !hasTimeout(timeoutMs)) return next(req);

  return next(req).pipe(
    timeout(timeoutMs),
    catchError((error: unknown) => {
      if (!(error instanceof TimeoutError)) return throwError(() => error);
      return throwError(
        () =>
          new HttpErrorResponse({
            status: 0,
            statusText: 'Timeout',
            url: req.urlWithParams,
            error: { message: REQUEST_TIMEOUT_MESSAGE },
          }),
      );
    }),
  );
};
